import React from 'react';
import { Wrapper } from './style';
// import bannerImg1 from '../../assets/images/banner101.jpg';
// import bannerImg2 from '../../assets/images/banner102.jpg';
// import bannerImg3 from '../../assets/images/banner103.jpg';
// import bannerImg4 from '../../assets/images/banner104.jpg';
import bannerImg1 from '../../assets/images/offer_pay_2_mobile.gif';
import bannerImg6 from '../../assets/images/Pay2moible Recharge-2.gif';
import bannerImg7 from '../../assets/images/Travel.gif';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

export default function OfferBanner() {
	return (
		<Wrapper className="d-m-none">
			<Carousel autoPlay={true} infiniteLoop={true} interval={3000}>
				{/* <div className="bannerItem">
					<img src={bannerImg3} alt="bannerImg" />
				</div> */}
				{/* <div className="bannerItem" onClick={() => window.open('https://tripscroll.com/', '_blank')}>
					<img src={bannerImg2} alt="bannerImg" style={{ cursor: 'pointer' }} />
				</div> */}
				<div className="bannerItem">
					<img src={bannerImg1} alt="bannerImg" lazy />
				</div>

				<div className="bannerItem">
					<img src={bannerImg6} alt="bannerImg" lazy />
				</div>
				<div className="bannerItem">
					<img src={bannerImg7} alt="bannerImg" lazy />
				</div>
				{/* <div className='bannerItem'>
                <img src={bannerImg4} alt="bannerImg"  />
                </div> */}
			</Carousel>
		</Wrapper>
	);
}
